module.exports = __webpack_public_path__ + "img/robots.0a9fcc18.png";